import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class LetterDocumentService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESSLetterDocumentTypeMasterInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterDocumentTypeMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSLetterDocumentTypeMasterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterDocumentTypeMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSLetterTemplateMasterInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplateMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSLetterTemplateMasterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplateMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterTemplate_UploadFile(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplate_Upload/File`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterTemplate_LoadEmpForLetter(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplate_LoadEmpFor/Letter`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterTemplateGenerationRequest_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplateGenerationRequest_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterTemplateGenerationRequest_GenerateOneLetter(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplateGenerationRequest_Generate/OneLetter`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterTemplateGenerationRequestSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterTemplateGenerationRequest/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LetterEmployeeAcknowledgement(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LetterEmployee/Acknowledgement`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeLetterDetailsLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeLetterDetails/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ZoopEsignProcess(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ZoopEsign/Process`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  fetchingTransectionDetailsWithgroupId(Detail: any) {
    return this.http.post<any>(environment.API_URL + `fetchingTransectionDetailsWith/groupId`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
